import { useStoresStore } from "~/store/stores";

export default (prefix: string = "") => {
  const { seoMetaCity } = storeToRefs(useStoresStore());
  const metaTitle = computed(
    () =>
      `${prefix} — в каталоге на сайте Магнит Косметик | ${seoMetaCity.value}`,
  );
  const metaDesc = computed(
    () =>
      `${prefix} смотреть цену в каталоге на сайте Магнит Косметик. Товары для дома, бытовая химия и косметика в городе ${seoMetaCity.value}. Следите за акциями и скидками.`,
  );
  const metaKeywords = computed(
    () =>
      `${prefix}, Магнит Косметик онлайн, цены, акции и скидки, каталог товаров, купить в городе ${seoMetaCity.value}, дёшево, магазин косметики, бытовая химия, товары для дома, средства для уборки, чистящие средства, средства гигиены`,
  );

  return {
    metaTitle,
    metaDesc,
    metaKeywords,
  };
};
